import { AbstractModel, DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { TncLicenseStatus } from './tnc-license-status';

@inheritSerialization(AbstractModel)
export class TncLicense extends AbstractModel {
  @autoserialize
  description: string;

  @autoserializeAs(Date)
  expirationDate: Date;

  @autoserialize
  isActive: boolean;

  @autoserialize
  issuingAuthority: string;

  @autoserialize
  licenseNumber: string;

  @autoserializeAs(TncLicenseStatus)
  tncLicenseStatus: TncLicenseStatus;

  static OnSerialized(instance: TncLicense, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.expirationDate)) {
      json.expirationDate = DateUtil.serializeLocalDate(instance.expirationDate);
    }
  }

  static OnDeserialized(instance: TncLicense, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['expirationDate'])) {
      instance.expirationDate = DateUtil.deserializeLocalDate(json['expirationDate']);
    }
  }
}
